import React from "react";
import PropTypes from "prop-types";
import Form from "../Form/form";
import {controlPropTypes} from "../formhelpers";

class Grid extends React.Component {
    render() {
        const {
            descriptor
        } = this.props;
        const config = descriptor.config || {};
        const selector = `control-container-${descriptor.key}`;
        const summaryClass = config.style === "summary"
            ? " control-layout-grid-summary"
            : "";
        return (
            <table
                id={descriptor.id}
                className={`control-layout-grid${summaryClass}`}
            >
                <tbody className={selector}>
                    <Form {...this.props} />
                </tbody>
            </table>
        );
    }
}

Grid.defaultProps = {
    descriptor: {},
    controlOnly: true,
    placeholder: true
};

Grid.propTypes = {
    ...controlPropTypes({
        style: PropTypes.oneOf(["summary"])
    }, false, true),
    propsResolver: PropTypes.func.isRequired,
    onCommitChange: PropTypes.func, // not required
};

export default Grid;



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/Layout/grid.js